module.exports = __webpack_public_path__ + "img/Support-skill-421.43211ae3.png";